const normalizeRole = (value) => String(value || "")
  .trim()
  .toLocaleLowerCase("tr-TR")
  .replace(/ı/g, "i")
  .replace(/ş/g, "s")
  .replace(/ğ/g, "g")
  .replace(/ü/g, "u")
  .replace(/ö/g, "o")
  .replace(/ç/g, "c");

export const memberUid = (member) => String(member?.uid || member?.id || "");

export const memberProfileRole = (member) => normalizeRole(
  member?.profilRol
  || member?.rol
  || member?.profileRole
  || member?.raw?.profilRol
  || member?.raw?.rol
  || member?.role
);

export const isParentMember = (member) => ["anne", "baba", "mother", "father", "ebeveyn", "parent"]
  .includes(memberProfileRole(member));

export const isChildMember = (member) => ["cocuk", "bebek", "child", "baby"]
  .includes(memberProfileRole(member));

export function canManageChildMember({ actor, target, isFamilyAdmin = false }) {
  if (isFamilyAdmin) return true;
  if (!actor || !target) return false;
  if (memberUid(actor) && memberUid(actor) === memberUid(target)) return true;
  return isParentMember(actor) && isChildMember(target);
}

export const memberBloodType = (member) => (
  member?.bloodType
  || member?.kanGrubu
  || member?.bloodGroup
  || member?.healthProfile?.bloodType
  || member?.healthProfile?.kanGrubu
  || member?.healthProfile?.bloodGroup
  || member?.raw?.healthProfile?.bloodType
  || member?.raw?.healthProfile?.kanGrubu
  || ""
);
